const routes = {
	'/trade-inquiries': '交易查询',
};

export {
	routes,
};
